import { combineReducers } from "redux";
import { loginReducer } from "./modules/login/index";
import { signUpReducer } from "./modules/signup/index";
import { salonsSearchReducer } from "./modules/getSalonsOnSearch/index";
import { servicesSearchReducer } from "./modules/getServicesOnSearch/index";
import snackbarReducer from "./modules/snackbar/index";
import { singleServiceReducer } from "./modules/getServicesBySalonId/index";
import { createBookingReducer } from "./modules/createBooking/index";
import { timeslotsReducer } from "./modules/getTimeslots/index";

const rootReducer = combineReducers({
  loginReducer,
  signUpReducer,
  salonsSearchReducer,
  servicesSearchReducer,
  snackbarReducer,
  singleServiceReducer,
  createBookingReducer,
  timeslotsReducer,
});

export default rootReducer;
